import React from 'react';
import moment from "moment-timezone";
import CustomCellRender from "components/common/CustomCellRender";

export const laoExportDRPColumns = {
    columnOrder: [

        {
            title: 'plant_origin', field: "orderOriginId",
            render: rowData => {
                return <CustomCellRender id="orderOriginId" value={rowData?.orderOrigin?.id} />
            }
        },
        {
            title: 'dest_plant', field: "orderDestinationId",
            render: rowData => {
                return <CustomCellRender id="orderDestinationId" value={rowData?.orderDestination?.id} />
            }
        },
        {
            title: 'storage_location', field: "storageLocation",
            render: rowData => {
                return <CustomCellRender id="storageLocation" value={rowData?.storageLocation} />
            }
        },
        {
            title: 'availability_date', field: "availabilityDate",
            render: rowData => {
                return <CustomCellRender id="availabilityDate" value={rowData?.availabilityDate} />
            }
        },
        {
            title: 'priority', field: "priority",
            render: rowData => {
                return <CustomCellRender id="priority" value={rowData?.priority} />
            }
        },
        {
            title: 'sku', field: "materialNum",
            render: rowData => {
                return <CustomCellRender id="materialNum" value={rowData?.materialNum} />
            }
        },
        {
            title: 'description', field: "itemDesc",
            render: rowData => {
                return <CustomCellRender id="itemDesc" value={rowData?.itemDesc} />
            }
        },
        {
            title: 'quantity', field: "packedQty",
            render: rowData => {
                return <CustomCellRender id="packedQty" value={rowData?.packedQty} />
            }
        },
        {
            title: 'volume_v3', field: "packedQtyVolume",
            render: rowData => {
                return <CustomCellRender id="packedQtyVolume" value={rowData?.packedQtyVolume} />
            }
        },
        {
            title: 'pallets', field: "palletsQty",
            render: rowData => {
                return <CustomCellRender id="palletsQty" value={rowData?.palletsQty} />
            }
        }
    ],
    columnConfiguration: (d) => {
        return {
            orderOriginId: d?.orderOrigin?.id ? d?.orderOrigin?.id : '-',
            orderDestinationId: d?.orderDestination?.id ? d.orderDestination.id : '-',
            availabilityDate: d?.availabilityDate ? moment(d.availabilityDate).format(`DD-MM-YYYY`) : '-'
        }
    }
};